import React from 'react';
import { shapes } from 'react-data-grid';
import _ from 'lodash';

const { ExcelColumn } = shapes;

class FilterByStart extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.inputRef = null;
  }

  componentDidMount() {
    const { getValidFilterValues } = this.props;
    if (_.isFunction(getValidFilterValues)) {
      this.inputRef.value = getValidFilterValues(this.props.column.key);
    }
  }

  filterValues(row, columnFilter, columnKey) {
    if (columnFilter.filterTerm == null) {
      return true;
    }
    let result = false;
    // implement default filter logic
    const value = row[columnKey];
    const rule = columnFilter.filterTerm;
    if (value && value.indexOf(rule) === 0) {
      result = true;
    }
    return result;
  }

  handleChange(e) {
    let value = e.target.value;
    this.props.onChange({ filterTerm: value, column: this.props.column, rawValue: value, filterValues: this.filterValues, });
  }

  render() {
    let inputKey = 'header-filter-' + this.props.column.key;
    let columnStyle = {
      float: 'left',
      marginRight: 0,
      marginTop: '5px',
      maxWidth: '100%',
    };

    return (
      <div style={columnStyle}>
        <input ref={inputRef => this.inputRef = inputRef} key={inputKey} type="text" placeholder="e.g. 01" className="form-control input-sm byStart" onChange={this.handleChange} />
      </div>
    );
  }
}

FilterByStart.propTypes = {
  onChange: React.PropTypes.func.isRequired,
  column: React.PropTypes.shape(ExcelColumn),
};

export default FilterByStart;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/filterByStart.jsx